import { create } from "zustand";

const STORAGE_KEY = "reporting-sidebar-collapsed-sections";

function loadCollapsedSections(): Set<string> {
  if (typeof window === "undefined") return new Set();
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return new Set(JSON.parse(stored) as string[]);
  } catch {
    //
  }
  return new Set();
}

function persistCollapsedSections(sections: Set<string>) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...sections]));
  } catch {
    //
  }
}

type SidebarSectionsState = {
  collapsedSections: Set<string>;
  toggleSection: (label: string) => void;
  expandSection: (label: string) => void;
};

export const useExpandedSidebarSectionsStore = create<SidebarSectionsState>(
  (set) => ({
    collapsedSections: loadCollapsedSections(),
    toggleSection: (label: string) =>
      set((state) => {
        const next = new Set(state.collapsedSections);
        if (next.has(label)) {
          next.delete(label);
        } else {
          next.add(label);
        }
        persistCollapsedSections(next);
        return { collapsedSections: next };
      }),
    expandSection: (label: string) =>
      set((state) => {
        if (!state.collapsedSections.has(label)) return state;
        const next = new Set(state.collapsedSections);
        next.delete(label);
        persistCollapsedSections(next);
        return { collapsedSections: next };
      }),
  }),
);
